import extend from './extend';
export var UserProjectStatus;
(function (UserProjectStatus) {
    UserProjectStatus[UserProjectStatus["Invited"] = 1] = "Invited";
    UserProjectStatus[UserProjectStatus["Active"] = 2] = "Active";
    UserProjectStatus[UserProjectStatus["Recommended"] = 3] = "Recommended";
    UserProjectStatus[UserProjectStatus["Rejected"] = 4] = "Rejected";
    UserProjectStatus[UserProjectStatus["Added"] = 5] = "Added";
    UserProjectStatus[UserProjectStatus["InReview"] = 6] = "InReview";
    UserProjectStatus[UserProjectStatus["Inactive"] = 7] = "Inactive";
    UserProjectStatus[UserProjectStatus["Disqualified"] = 8] = "Disqualified";
    UserProjectStatus[UserProjectStatus["Staging"] = 9] = "Staging";
})(UserProjectStatus || (UserProjectStatus = {}));
const map = new Map([
    [UserProjectStatus.Invited, { name: 'Invited' }],
    [UserProjectStatus.Active, { name: 'Active' }],
    [UserProjectStatus.Recommended, { name: 'Recommended' }],
    [UserProjectStatus.Rejected, { name: 'Rejected' }],
    [UserProjectStatus.Added, { name: 'Added' }],
    [UserProjectStatus.InReview, { name: 'In-Review' }],
    [UserProjectStatus.Inactive, { name: 'Inactive' }],
    [UserProjectStatus.Disqualified, { name: 'Disqualified' }],
    [UserProjectStatus.Staging, { name: 'Staging' }],
]);
export default {
    UserProjectStatus: extend(map),
};
